export default "__VITE_ASSET__09672e3e__"